<template>
<div class="learning-level-list">
<div class="container-fluid">
  <div class="table-responsive margin-Top-6Perc overflowXHidden">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Level Name</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="learninglevelObj in getLearningLevelList" :key="learninglevelObj.LearningLevelId" v-bind:learninglevelObj="learninglevelObj" > 
          <td class="border-right text-align-center col-lg-6">{{learninglevelObj.LearningLevelName}}</td>
          <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(learninglevelObj.CreatedTS)}}</td>
          <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(learninglevelObj.UpdatedTS)}}</td>
          <td class="border-right text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'view', learninglevelObj)"> View  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'update', learninglevelObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', learninglevelObj)"> Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteLearningLevelString" v-bind:postfixString="postDeleteLearningLevelString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
  <view-learning-level-overlay v-if="showViewLearningLevelOverlay" :selectedLearningLevelObj="getSelectedLearningLevelObj" @closeOverlay="CloseCurrentOpenLearningOverlay"></view-learning-level-overlay>
  <update-learning-level-overlay v-if="showUpdateLearningLevelOverlay" :selectedLearningLevelObj="getSelectedLearningLevelObj" @closeOverlay="CloseCurrentOpenLearningOverlay"></update-learning-level-overlay>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import UpdateLearningLevelOverlay from '@/components/learning_level/UpdateLearningLevelOverlay'
import ViewLearningLevelOverlay from '@/components/learning_level/ViewLearningLevelOverlay'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { learningLevelService } from '@/server-util/learning-level-services'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import filter from 'lodash/filter'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['learningLevelList'],
  data: function () {
    return {
      showViewLearningLevelOverlay: false,
      showUpdateLearningLevelOverlay: false,
      selectedLearningLevelObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      prefixDeleteLearningLevelString: '',
      postDeleteLearningLevelString: '',
      showConfirmationBox: false
    }
  },
  name: 'learning-level-list',
  methods: {
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteSelectedLearningLevel()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    CloseCurrentOpenLearningOverlay (value) {
      const closeOverlay = value.closeOverlay
      const updatedObj = value.updatedObj
      if (updatedObj !== null) {
        const currObjIndex = findIndex(this.getLearningLevelListFromState, (obj) => {
          return obj.LearningLevelId === updatedObj.LearningLevelId
        })
        if (currObjIndex !== -1) {
          this.getLearningLevelListFromState[currObjIndex] = updatedObj
        }
        this.$emit('updatedLearningLevelList', this.learningLevelList)
      }
      this.showViewLearningLevelOverlay = !closeOverlay
      this.showUpdateLearningLevelOverlay = !closeOverlay
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = !closeOverlay
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performClickOperation: function (event, selectedOperation, selectedObj) {
      this.selectedLearningLevelObj = selectedObj
      // console.log(JSON.stringify(this.selectedLearningLevelObj))
      switch (selectedOperation) {
        case 'view':
          this.showViewLearningLevelOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'update':
          this.showUpdateLearningLevelOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteLearningLevelString = 'Are you sure you want delete '
          this.postDeleteLearningLevelString = '\'' + this.selectedLearningLevelObj.LearningLevelName + '\' level?'
          break
      }
    },
    deleteSelectedLearningLevel: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedLearningLevelObj.LearningLevelId !== undefined &&
        this.selectedLearningLevelObj.LearningLevelId !== null &&
        this.selectedLearningLevelObj.LearningLevelId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        learningLevelService
          .deleteLearningLevel(
            storeObj.state.access_token,
            this.selectedLearningLevelObj.LearningLevelId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Remove selected Learning level object
                this.removeSelectedObjFromList()
                _this.$store.state.isLoading = false
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'LearningLevelId is NULL hence declined DELETE LEARNING LEVEL OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    removeSelectedObjFromList: function () {
      var listToReturn = filter(this.getLearningLevelListFromState, (obj) => {
        return this.selectedLearningLevelObj.LearningLevelId !== obj.LearningLevelId
      })
      this.$emit('updatedLearningLevelList', listToReturn)
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'update-learning-level-overlay': UpdateLearningLevelOverlay,
    'view-learning-level-overlay': ViewLearningLevelOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getLearningLevelList: {
      get: function () {
        return this.learningLevelList
      }
    },
    getSelectedLearningLevelObj: {
      get: function () {
        return this.selectedLearningLevelObj
      }
    },
    getLearningLevelListFromState: {
      get: function () {
        return this.$store.state.learningLevelList
      },
      set: function (newValue) {
        this.$store.state.learningLevelList = newValue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.learning-level-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.overflowXHidden {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/learning_level/LearningLevelList.vue